import { valueConverter } from "aurelia-binding";

@valueConverter("patientMessageStatusIdColor")
export class PatientMessageStatusIdColor {
    public toView(id: string) {
        switch (parseInt(id, 10)) {
            case 1:
                return "success";
            case 2:
                return "warning";
            default:
                return "";
        }
    }
}
